import { DataEntity } from 'src/app/models/data-entities';
import { Component, OnInit, Input } from '@angular/core';
import { WorkflowContextService } from 'src/app/services';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-de-label',
    templateUrl: './de-label.component.html',
    styleUrls: ['./de-label.component.css'],
    standalone: false
})
export class DeLabelComponent implements OnInit {
  @Input() for: string;
  @Input() entity: DataEntity;
  @Input() displayOnly = false;
  templateForPermitForm: boolean = false;         // Added by Vipul on 17/12/2025

  constructor(
     public layoutService: LayoutService,
    context : WorkflowContextService
  ) {
    // Started by Vipul on 17/12/2025
   layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 17/12/2025
  }

  ngOnInit() {}
}
